import React, { ReactElement } from 'react'
import NeedsReviewIcon from 'src/assets/svgs/ReceiptRecoveryNeedsReviewPlatedIcon.svg'
import WaitingOnSpenderIcon from 'src/assets/svgs/ReceiptRecoveryWaitingOnSpenderPlatedIcon.svg'
import { ReceiptState } from 'src/feature/ReceiptRecovery/receiptRecovery.types'

type InterventionQueueState = Exclude<ReceiptState, 'receipt-reconciled'>

interface InterventionQueueIconProps {
  state: InterventionQueueState
}

const InterventionQueueIcon = ({
  state,
}: InterventionQueueIconProps): ReactElement => {
  const iconSource =
    state === 'needs-review' ? NeedsReviewIcon : WaitingOnSpenderIcon

  return (
    <span
      aria-hidden="true"
      className={`interventionQueueIcon interventionQueueIcon--${state}`}
    >
      <img alt="" src={iconSource} />
    </span>
  )
}

export default InterventionQueueIcon
